/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { Brand } from '@components/ui/Brand';
import { Grid, Stack, styled, Theme, Typography, useMediaQuery } from '@mui/material';
import { LoginLangDropdown } from 'components/login/LoginLangDropdown';
import dynamic from 'next/dynamic';
import { FC } from 'react';

import { LoginForm } from './LoginForm';

import config from '@/config';

const PageDefault = dynamic(() => import('@components/ui/Page/PageDefault'));

const LoginViewMenu = styled(Stack, {
  name: 'LoginView',
  slot: 'Menu',
  shouldForwardProp: (prop) => prop !== 'isMobile',
})<{ isMobile: boolean }>(({ theme, isMobile }) => ({
  flexGrow: 0,
  flexBasis: 375,
  padding: theme.spacing(5),
  paddingBottom: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  ...(isMobile && {
    flexBasis: '100%',
  }),
}));

const LoginViewHead = styled(Grid, {
  name: 'LoginView',
  slot: 'Head',
})({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
});

const LoginView: FC = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Stack direction="row" flexGrow={1}>
      <LoginViewMenu isMobile={isMobile} direction="column" justifyContent="space-between">
        <LoginViewHead container>
          <Brand />
          <LoginLangDropdown />
        </LoginViewHead>

        <Stack direction="column" flexGrow={1} justifyContent="center">
          <LoginForm />
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          alignSelf="stretch"
          justifyContent="space-between"
        >
          <Typography variant="caption" sx={{ fontWeight: 500 }}>
            © {new Date().getFullYear()} MAYORAL MODA INFANTIL S.A.U.
          </Typography>

          <Typography variant="caption" sx={{ fontWeight: 500, color: 'grey.600' }}>
            v{config.public.version}
          </Typography>
        </Stack>
      </LoginViewMenu>
      {!isMobile && <PageDefault />}
    </Stack>
  );
};

export default LoginView;
